import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Users, Filter } from 'lucide-react';

const STATUS_STYLES = {
  active: 'bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-950 dark:text-emerald-300',
  on_notice: 'bg-orange-50 text-orange-700 border-orange-200 dark:bg-orange-950 dark:text-orange-300',
  exited: 'bg-slate-100 text-slate-600 border-slate-200 dark:bg-slate-800 dark:text-slate-300',
};

export default function EmployeeCountCard({ filtered, total, filterLabels }) {
  const counts = {};
  for (let i = 0; i < filtered.length; i++) {
    const s = filtered[i].status || 'active';
    counts[s] = (counts[s] || 0) + 1;
  }
  const statusKeys = Object.keys(counts).sort();
  const isFiltered = filterLabels.length > 0;

  return (
    <Card data-testid="employee-count-card">
      <CardContent className="py-3 px-4">
        <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
          <div className="flex items-center gap-2">
            <Users className="h-4 w-4 text-muted-foreground" />
            <span className="text-2xl font-bold" data-testid="employee-count-value">{filtered.length}</span>
            <span className="text-sm text-muted-foreground">
              {isFiltered ? `of ${total} employees match` : 'employees'}
            </span>
          </div>
          <div className="flex flex-wrap items-center gap-1.5">
            {statusKeys.map(function(s) {
              return (
                <Badge key={s} variant="outline" className={'text-xs capitalize ' + (STATUS_STYLES[s] || '')} data-testid={'count-status-' + s}>
                  {s.replace('_', ' ')}: {counts[s]}
                </Badge>
              );
            })}
          </div>
          {isFiltered && (
            <div className="flex flex-wrap items-center gap-1.5 ml-auto">
              <Filter className="h-3.5 w-3.5 text-muted-foreground" />
              {filterLabels.map(function(label) {
                return <Badge key={label} variant="secondary" className="text-xs">{label}</Badge>;
              })}
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
